/* Infinel global.js — sidövergripande beteenden. Vanilla, inga beroenden.
   Genomgående princip: markupen fungerar utan JS, det här filen förbättrar den.

   Innehåll:
     1. Hjälpare (fetch-routes, mätevents, fokusordning)
     2. Mobil-drawer med panelbläddring
     3. Megameny (hover-intent, Escape, en panel åt gången)
     4. Predictive search (combobox mot Shopifys Predictive Search API)
     5. Mini-cart (Cart Ajax API + Section Rendering)
     6. Varukorgssidans stegare
     7. Katalogsidor: filter-sheet-Escape, mätevent, "Visa fler"
     8. Relaterade produkter (Product Recommendations API)
     9. Utskrift: fäll ut alla <details> så specifikationerna kommer med
*/
(function () {
  'use strict';

  /* ============================================================
     1. Hjälpare
     ============================================================ */

  var config = window.Infinel || {};
  var routes = config.routes || {};

  /** Mätevent: DOM-event alltid, dataLayer när ett analysverktyg finns.
      Utan verktyg är detta en no-op — inga externa anrop läggs på sidan. */
  function track(name, detail) {
    document.dispatchEvent(new CustomEvent('infinel:' + name, { detail: detail || {} }));
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      var payload = { event: 'infinel_' + name };
      if (detail) {
        Object.keys(detail).forEach(function (key) {
          payload[key] = detail[key];
        });
      }
      window.dataLayer.push(payload);
    }
  }

  window.Infinel = config;
  config.track = track;

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        // getClientRects, inte offsetParent: allt inuti en <dialog> har
        // offsetParent === null eftersom dialogen är fixed-positionerad.
        return el.getClientRects().length > 0;
      }
    );
  }

  /* ============================================================
     2. Mobil-drawer med panelbläddring
     ============================================================ */

  (function drawerModule() {
    var drawer = document.getElementById('mobile-drawer');
    var openBtn = document.querySelector('[data-drawer-open]');
    if (!drawer || !openBtn) return;

    var viewport = drawer.querySelector('.mobile-drawer__viewport');
    var titleEl = drawer.querySelector('[data-drawer-title]');
    var backBtn = drawer.querySelector('[data-drawer-back]');
    var rootTitle = titleEl ? titleEl.textContent : 'Meny';
    var current = drawer.querySelector('[data-drawer-panel="root"]');
    var leaveTimer = null;

    function panelById(id) {
      return viewport ? viewport.querySelector('[data-drawer-panel="' + id + '"]') : null;
    }

    function goTo(id, moveFocus) {
      var next = panelById(id);
      if (!next || next === current) return;

      window.clearTimeout(leaveTimer);
      var previous = current;
      var isRoot = id === 'root';

      next.hidden = false;
      // Framtvinga layout så att övergången startar från utgångsläget i CSS.
      void next.offsetWidth;

      previous.classList.remove('is-current');
      if (!isRoot) previous.classList.add('is-leaving');
      next.classList.remove('is-leaving');
      next.classList.add('is-current');
      current = next;

      leaveTimer = window.setTimeout(function () {
        previous.classList.remove('is-leaving');
        previous.hidden = true;
      }, 220);

      if (titleEl) {
        titleEl.textContent = isRoot ? rootTitle : next.getAttribute('data-drawer-panel-title') || rootTitle;
      }
      if (backBtn) backBtn.hidden = isRoot;

      if (moveFocus === false) return;
      var first = focusables(next)[0];
      if (first) first.focus();
    }

    function open() {
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
      openBtn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
    }

    openBtn.addEventListener('click', open);

    drawer.addEventListener('click', function (event) {
      // Klick på backdrop (dialogen själv, inte innehållet) stänger.
      if (event.target === drawer) {
        close();
        return;
      }

      var toBtn = event.target.closest('[data-drawer-to]');
      if (toBtn) {
        goTo(toBtn.getAttribute('data-drawer-to'));
        return;
      }

      if (event.target.closest('[data-drawer-back]')) {
        goTo('root');
        return;
      }

      if (event.target.closest('[data-drawer-close]')) {
        close();
      }
    });

    // Escape backar ett steg i panelbläddringen innan den stänger drawern.
    drawer.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (current && current.getAttribute('data-drawer-panel') !== 'root') {
        event.preventDefault();
        goTo('root');
      }
    });

    drawer.addEventListener('close', function () {
      openBtn.setAttribute('aria-expanded', 'false');
      // Panelen nollställs UTAN fokusflytt — fokus hör hemma på utlösaren igen.
      goTo('root', false);
      openBtn.focus();
    });
  })();

  /* ============================================================
     3. Megameny
     ============================================================
     <details> är basen (klick + tangentbord utan JS). Här läggs hover-öppning
     på desktop till — CSS kan inte göra det, eftersom en stängd <details> inte
     renderar sina barn alls. */

  (function megamenuModule() {
    var menus = Array.prototype.slice.call(document.querySelectorAll('.site-nav [data-megamenu]'));
    if (!menus.length) return;

    function closeAll(except) {
      menus.forEach(function (menu) {
        if (menu !== except) menu.removeAttribute('open');
      });
    }

    menus.forEach(function (menu) {
      menu.addEventListener('toggle', function () {
        if (menu.open) closeAll(menu);
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.site-nav [data-megamenu]')) closeAll(null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = menus.filter(function (menu) {
        return menu.open;
      })[0];
      if (!open) return;
      var summary = open.querySelector(':scope > summary');
      closeAll(null);
      if (summary) summary.focus();
    });

    var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 900px)');
    var hoverTimer = null;

    menus.forEach(function (menu) {
      menu.addEventListener('mouseenter', function () {
        if (!hoverQuery.matches) return;
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () {
          menu.setAttribute('open', '');
        }, 90);
      });

      menu.addEventListener('mouseleave', function () {
        if (!hoverQuery.matches) return;
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () {
          menu.removeAttribute('open');
        }, 180);
      });
    });
  })();

  /* ============================================================
     4. Predictive search
     ============================================================ */

  /* SEARCH-003a: artikelnummeruppslag i fasettjänsten (filter.infinel.se/v1/lookup).
     Shopifys sök indexerar inga metafält och delar koder vid bindestreck, så
     "MC211CS20" hittar inte "MC211CS-20". Uppslaget kompletterar bara: varje fel,
     timeout eller avstängd inställning lämnar Shopifys vanliga förslag orörda. */
  var mpnLookup = (function () {
    var settings = config.mpnLookup || {};
    var endpoint = typeof settings.endpoint === 'string' ? settings.endpoint.replace(/\/+$/, '') : '';
    var enabled = settings.enabled === true && /^https:\/\/[a-z0-9.-]+$/.test(endpoint);
    var TIMEOUT_MS = 800;
    var MAX_RESULTS = 5;

    /* Spegel av isCodeLikeQuery i pipelinens identifierLookup.ts. Samma
       falltabell testas på båda sidor (tests/mpn-lookup.test.cjs). */
    function isCodeLike(term) {
      var trimmed = String(term || '').trim();
      if (!trimmed || trimmed.length > 64) return false;
      if (trimmed.split(/\s+/).length > 3) return false;
      var key = trimmed.normalize('NFKC').toLowerCase().replace(/[^a-z0-9]/g, '');
      return key.length >= 4 && key.length <= 40 && /[0-9]/.test(key);
    }

    function validResult(r) {
      if (!r || typeof r !== 'object') return false;
      if (typeof r.url !== 'string' || !/^\/products\/[^/?#]+$/.test(r.url)) return false;
      if (typeof r.title !== 'string' || !r.title || r.title.length > 4096) return false;
      if (typeof r.vendor !== 'string' || r.vendor.length > 4096) return false;
      if (!Number.isSafeInteger(r.priceOre) || r.priceOre < 0) return false;
      if (r.image !== null && (typeof r.image !== 'string' || r.image.indexOf('https://cdn.shopify.com/') !== 0)) return false;
      if (typeof r.mpn !== 'string' || !r.mpn || r.mpn.length > 64) return false;
      return r.match === 'exact' || r.match === 'prefix';
    }

    /* Löser alltid, aldrig reject: [] vid fel, timeout eller avbrott. */
    function fetchResults(term, parentSignal) {
      if (!enabled || !isCodeLike(term)) return Promise.resolve([]);
      var controller = new AbortController();
      var timer = window.setTimeout(function () { controller.abort(); }, TIMEOUT_MS);
      if (parentSignal) {
        if (parentSignal.aborted) controller.abort();
        else parentSignal.addEventListener('abort', function () { controller.abort(); });
      }
      return fetch(endpoint + '/v1/lookup?q=' + encodeURIComponent(term.trim()), {
        signal: controller.signal, credentials: 'omit', headers: { Accept: 'application/json' }
      })
        .then(function (response) { return response.ok ? response.json() : { results: [] }; })
        .then(function (body) {
          var results = body && Array.isArray(body.results) ? body.results.slice(0, MAX_RESULTS) : [];
          return results.every(validResult) ? results : [];
        })
        .catch(function () { return []; })
        .then(function (results) { window.clearTimeout(timer); return results; });
    }

    function formatPrice(ore) {
      var whole = ore % 100 === 0;
      return new Intl.NumberFormat('sv-SE', {
        style: 'currency', currency: 'SEK',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
      }).format(ore / 100);
    }

    function el(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }

    /* En rad i Shopifys ps__row-form. Allt innehåll via textContent. */
    function row(result, attributes) {
      var link = el('a', 'ps__row');
      link.href = result.url;
      Object.keys(attributes).forEach(function (name) { link.setAttribute(name, attributes[name]); });
      var media = el('span', 'ps__media');
      if (result.image) {
        var img = el('img', 'ps__img');
        img.src = result.image; img.alt = ''; img.loading = 'lazy'; img.width = 48; img.height = 48;
        media.appendChild(img);
      }
      var body = el('span', 'ps__body');
      body.appendChild(el('span', 'ps__vendor', (result.vendor ? result.vendor + ' · ' : '') + 'Art.nr ' + result.mpn));
      body.appendChild(el('span', 'ps__title', result.title));
      link.appendChild(media);
      link.appendChild(body);
      link.appendChild(el('span', 'ps__price', formatPrice(result.priceOre)));
      return link;
    }

    return { enabled: enabled, isCodeLike: isCodeLike, fetchResults: fetchResults, row: row, el: el };
  })();
  window.InfinelLookup = { isCodeLike: mpnLookup.isCodeLike };

  (function predictiveSearchModule() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-predictive-search]'));
    if (!forms.length || !routes.predictiveSearch) return;

    var MIN_LENGTH = 2;
    var DEBOUNCE_MS = 220;
    var MAX_LENGTH = 200;
    var MAX_HTML_LENGTH = 131072;
    var TIMEOUT_MS = 6000;

    forms.forEach(function (form, formIndex) {
      var input = form.querySelector('[data-predictive-search-input]');
      var panel = form.querySelector('[data-predictive-search-results]');
      var status = form.querySelector('[data-predictive-search-status]');
      if (!input || !panel) return;

      var options = [];
      var activeIndex = -1;
      var timer = null;
      var controller = null;
      var lastTerm = '';
      var sequence = 0;
      var deadline = null;

      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      panel.id = panel.id || 'ps-panel-' + formIndex;
      input.setAttribute('aria-controls', panel.id);

      function setActive(index) {
        if (options[activeIndex]) {
          options[activeIndex].classList.remove('is-active');
          options[activeIndex].setAttribute('aria-selected', 'false');
        }
        activeIndex = index;
        if (options[activeIndex]) {
          options[activeIndex].classList.add('is-active');
          options[activeIndex].setAttribute('aria-selected', 'true');
          input.setAttribute('aria-activedescendant', options[activeIndex].id);
          options[activeIndex].scrollIntoView({ block: 'nearest' });
        } else {
          input.removeAttribute('aria-activedescendant');
        }
      }

      function close() {
        sequence += 1;
        window.clearTimeout(timer);
        window.clearTimeout(deadline);
        if (controller) controller.abort();
        controller = null;
        timer = null;
        lastTerm = '';
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        options = [];
        activeIndex = -1;
        if (status) status.textContent = '';
      }

      function showLoading() {
        if (!panel.hidden) return;
        panel.innerHTML =
          '<div class="ps__loading" aria-hidden="true">' +
          '<span class="infinel-skeleton"></span><span class="infinel-skeleton"></span><span class="infinel-skeleton"></span>' +
          '</div>';
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function render(html, term, lookupResults) {
        if (html.length > MAX_HTML_LENGTH) throw new Error('Invalid suggestion size');
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var roots = parsed.querySelectorAll('[data-ps-panel]');
        if (roots.length !== 1 || parsed.querySelector('script, iframe, object, embed, form')) throw new Error('Invalid suggestions');
        var root = roots[0];
        var count = Number(root.getAttribute('data-ps-count'));
        if (!Number.isInteger(count) || count < 0 || count > 15) throw new Error('Invalid suggestion count');
        [root].concat(Array.prototype.slice.call(root.querySelectorAll('*'))).forEach(function (node) {
          Array.prototype.forEach.call(node.attributes, function (attribute) {
            if (/^on/i.test(attribute.name) || attribute.name === 'srcdoc') throw new Error('Invalid suggestion attribute');
          });
        });
        var links = root.querySelectorAll('[data-ps-option]');
        if (links.length > 16 || (count > 0 && !links.length)) throw new Error('Invalid suggestion options');
        links.forEach(function (link) {
          var url = new URL(link.getAttribute('href'), window.location.origin);
          if (link.tagName !== 'A' || link.getAttribute('role') !== 'option' || url.origin !== window.location.origin || !/^(?:\/[a-z]{2}(?:-[A-Za-z]{2})?)?\/(products|collections|search)(\/|$)/.test(url.pathname)) throw new Error('Invalid suggestion link');
        });
        var lookupShown = addLookupGroup(root, links, lookupResults || []);
        if (lookupShown) count += lookupShown;
        root.querySelectorAll('[id]').forEach(function (node) {
          var oldId = node.id;
          node.id = panel.id + '-' + oldId;
          root.querySelectorAll('[aria-labelledby]').forEach(function (labelled) {
            if (labelled.getAttribute('aria-labelledby') === oldId) labelled.setAttribute('aria-labelledby', node.id);
          });
        });
        var listbox = root.querySelector('[role="listbox"]');
        if (!listbox && count === 0) { listbox = root; root.setAttribute('role', 'listbox'); root.setAttribute('aria-label', 'Sökförslag'); }
        if (!listbox) throw new Error('Missing suggestion listbox');
        listbox.id = panel.id + '-listbox';
        panel.replaceChildren(root);
        input.setAttribute('aria-controls', listbox.id);
        options = Array.prototype.slice.call(panel.querySelectorAll('[data-ps-option]'));
        options.forEach(function (option, index) {
          option.id = panel.id + '-option-' + index;
          option.setAttribute('aria-selected', 'false');
        });
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        setActive(-1);

        if (status) {
          status.textContent = count
            ? count + ' förslag för ' + term
            : 'Inga förslag för ' + term;
        }
        track('search_suggest_open', { results: count });
      }

      /* Gruppen "Artikelnummer" överst i listboxen, högst tre rader, utan
         produkter som Shopify redan föreslår. Returnerar antalet tillagda rader. */
      function addLookupGroup(root, shopifyLinks, results) {
        var seen = {};
        Array.prototype.forEach.call(shopifyLinks, function (link) {
          seen[new URL(link.getAttribute('href'), window.location.origin).pathname] = true;
        });
        var fresh = results.filter(function (result) { return !seen[result.url]; }).slice(0, 3);
        if (!fresh.length) return 0;
        var listbox = root.querySelector('[role="listbox"]');
        if (!listbox) {
          var empty = root.querySelector('.ps__empty');
          if (empty) empty.remove();
          listbox = mpnLookup.el('ul', 'ps__list');
          listbox.setAttribute('role', 'listbox');
          listbox.setAttribute('aria-label', 'Sökförslag');
          root.appendChild(listbox);
        }
        var group = mpnLookup.el('li', 'ps__group');
        group.setAttribute('role', 'presentation');
        var title = mpnLookup.el('p', 'ps__group-title', 'Artikelnummer');
        title.id = 'ps-group-mpn';
        var list = mpnLookup.el('ul');
        list.setAttribute('role', 'group');
        list.setAttribute('aria-labelledby', 'ps-group-mpn');
        fresh.forEach(function (result) {
          var item = mpnLookup.el('li');
          item.setAttribute('role', 'presentation');
          item.appendChild(mpnLookup.row(result, { role: 'option', tabindex: '-1', 'data-ps-option': '', 'data-ps-mpn': result.match }));
          list.appendChild(item);
        });
        group.appendChild(title);
        group.appendChild(list);
        listbox.insertBefore(group, listbox.firstChild);
        track('search_lookup', { shown: fresh.length, match: fresh[0].match });
        return fresh.length;
      }

      function search(term, requestSequence) {
        if (requestSequence !== sequence) return;
        controller = new AbortController();
        var requestController = controller;
        showLoading();
        deadline = window.setTimeout(function () {
          if (requestSequence !== sequence) return;
          close();
          if (status) status.textContent = 'Sökförslagen kunde inte hämtas. Tryck på Sök.';
        }, TIMEOUT_MS);

        var url =
          routes.predictiveSearch +
          '?q=' +
          encodeURIComponent(term) +
          '&section_id=predictive-search' +
          '&resources[type]=product,collection,query' +
          '&resources[limit]=5' +
          '&resources[limit_scope]=each' +
          '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,variants.barcode' +
          '&resources[options][unavailable_products]=last';

        var lookupRequest = mpnLookup.fetchResults(term, requestController.signal);

        fetch(url, { signal: requestController.signal })
          .then(function (response) {
            if (!response.ok) throw new Error('Sökförslagen kunde inte hämtas');
            if (Number(response.headers.get('Content-Length')) > MAX_HTML_LENGTH) throw new Error('Invalid suggestion size');
            return response.text();
          })
          .then(function (html) {
            return lookupRequest.then(function (lookupResults) { return { html: html, lookupResults: lookupResults }; });
          })
          .then(function (result) {
            // Sen respons på en gammal term får aldrig skriva över en nyare.
            if (requestSequence !== sequence || requestController.signal.aborted || input.value.trim() !== term) return;
            window.clearTimeout(deadline);
            render(result.html, term, result.lookupResults);
            controller = null;
          })
          .catch(function (error) {
            if (requestSequence !== sequence || error.name === 'AbortError') return;
            close();
            if (status) status.textContent = 'Sökförslagen kunde inte hämtas. Tryck på Sök.';
          });
      }

      input.addEventListener('input', function () {
        var term = input.value.trim();
        if (term === lastTerm && !panel.hidden) return;
        close();
        if (term.length < MIN_LENGTH || term.length > MAX_LENGTH) return;
        lastTerm = term;
        var requestSequence = sequence;
        timer = window.setTimeout(function () {
          timer = null;
          search(term, requestSequence);
        }, DEBOUNCE_MS);
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          // Med öppen förslagslista tar Escape listan först — annars hade den
          // stängt hela mobildrawern som sökfältet ligger i.
          if (!panel.hidden || timer || controller) event.preventDefault();
          close();
          return;
        }
        if (event.key === 'Tab') { close(); return; }
        if (panel.hidden || !options.length) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActive((activeIndex + 1) % options.length);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActive((activeIndex - 1 + options.length) % options.length);
        } else if (event.key === 'Enter' && activeIndex > -1) {
          event.preventDefault();
          var option = options[activeIndex];
          track('search_suggest_click', { position: activeIndex });
          window.location.assign(option.href);
        }
      });

      panel.addEventListener('mousemove', function (event) {
        var option = event.target.closest('[data-ps-option]');
        if (!option) return;
        var index = options.indexOf(option);
        if (index > -1 && index !== activeIndex) setActive(index);
      });

      panel.addEventListener('click', function (event) {
        var option = event.target.closest('[data-ps-option]');
        if (!option) return;
        track('search_suggest_click', { position: options.indexOf(option) });
      });

      form.addEventListener('submit', close);
      var dialog = form.closest('dialog');
      if (dialog) dialog.addEventListener('close', close);

      form.addEventListener('focusout', function () {
        // Nästa tick: activeElement är inte uppdaterad än under focusout.
        window.setTimeout(function () {
          if (!form.contains(document.activeElement)) close();
        }, 0);
      });

      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) close();
      });
    });
  })();

  /* SEARCH-003a på söksidan: block ovanför resultaten när frågan är en kod och
     uppslaget hittar en produkt som inte redan syns bland träffarna. */
  (function searchPageLookupModule() {
    var container = document.querySelector('[data-mpn-lookup]');
    if (!container || !mpnLookup.enabled) return;
    var term = container.getAttribute('data-terms') || '';
    if (!mpnLookup.isCodeLike(term)) return;
    mpnLookup.fetchResults(term).then(function (results) {
      var seen = {};
      document.querySelectorAll('[data-product-grid] a[href]').forEach(function (link) {
        seen[new URL(link.getAttribute('href'), window.location.origin).pathname] = true;
      });
      var fresh = results.filter(function (result) { return !seen[result.url]; }).slice(0, 3);
      if (!fresh.length) return;
      var heading = mpnLookup.el('p', 'ps__group-title', 'Exakt träff på tillverkarens artikelnummer');
      var list = mpnLookup.el('ul', 'ps__list');
      fresh.forEach(function (result) {
        var item = mpnLookup.el('li');
        item.appendChild(mpnLookup.row(result, { 'data-mpn-match': result.match }));
        list.appendChild(item);
      });
      container.replaceChildren(heading, list);
      container.hidden = false;
      track('search_lookup_page', { shown: fresh.length, match: fresh[0].match });
    });
  })();

  /* ============================================================
     5. Mini-cart
     ============================================================ */

  (function miniCartModule() {
    var miniCart = document.getElementById('mini-cart');
    if (!miniCart) return;

    var openTriggers = document.querySelectorAll('[data-minicart-open]');
    var counters = document.querySelectorAll('[data-cart-count]');
    var lastFocused = null;

    function updateCount(count) {
      counters.forEach(function (counter) {
        counter.textContent = count;
        counter.hidden = count === 0;
        counter.setAttribute('aria-label', count + ' varor i varukorgen');
        if (count > 0) {
          counter.classList.remove('is-bumped');
          void counter.offsetWidth;
          counter.classList.add('is-bumped');
        }
      });
    }

    function open() {
      lastFocused = document.activeElement;
      if (typeof miniCart.showModal === 'function') {
        miniCart.showModal();
      } else {
        miniCart.setAttribute('open', '');
      }
      var close = miniCart.querySelector('[data-minicart-close]');
      if (close) close.focus();
    }

    function close() {
      if (typeof miniCart.close === 'function') {
        miniCart.close();
      } else {
        miniCart.removeAttribute('open');
      }
    }

    miniCart.addEventListener('close', function () {
      if (lastFocused && typeof lastFocused.focus === 'function' && document.contains(lastFocused)) {
        lastFocused.focus();
      }
    });

    /** Byter innehållet men behåller <dialog>-elementet, så öppet läge överlever. */
    function applySection(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var next = parsed.querySelector('[data-minicart-content]');
      var currentContent = miniCart.querySelector('[data-minicart-content]');
      if (!next || !currentContent) return 0;
      currentContent.replaceWith(next);
      return parseInt(next.getAttribute('data-cart-item-count'), 10) || 0;
    }

    function showError(form, message) {
      var slot = form.querySelector('[data-cart-error]');
      if (!slot) return;
      slot.textContent = message;
      slot.hidden = false;
    }

    function clearError(form) {
      var slot = form.querySelector('[data-cart-error]');
      if (!slot) return;
      slot.textContent = '';
      slot.hidden = true;
    }

    openTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        open();
      });
    });

    miniCart.addEventListener('click', function (event) {
      if (event.target === miniCart) {
        close();
        return;
      }
      if (event.target.closest('[data-minicart-close]')) {
        close();
        return;
      }

      var qtyTrigger = event.target.closest('[data-minicart-qty]');
      if (!qtyTrigger) return;

      event.preventDefault();
      var line = parseInt(qtyTrigger.getAttribute('data-minicart-index'), 10);
      var quantity = parseInt(qtyTrigger.getAttribute('data-minicart-qty'), 10);
      if (!line || isNaN(quantity) || quantity < 0) return;

      qtyTrigger.setAttribute('aria-busy', 'true');
      fetch(routes.cartChange || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'mini-cart' })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Varukorgen kunde inte uppdateras');
          return response.json();
        })
        .then(function (data) {
          var sections = data.sections || {};
          if (sections['mini-cart']) updateCount(applySection(sections['mini-cart']));
          track('cart_change', { line: line, quantity: quantity });
        })
        .catch(function () {
          // Fallback: varukorgssidan är alltid en fungerande väg.
          window.location.assign(routes.cart || '/cart');
        });
    });

    /* --- Lägg i varukorg: fångas för alla produktformulär på sidan --- */
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;

      event.preventDefault();
      clearError(form);

      var submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.classList.add('is-loading');

      var formData = new FormData(form);
      formData.append('sections', 'mini-cart');

      fetch(routes.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            // Shopify svarar med description på t.ex. slutsåld variant.
            showError(form, result.data.description || result.data.message || 'Varan kunde inte läggas i varukorgen.');
            return;
          }
          var sections = (result.data && result.data.sections) || {};
          if (sections['mini-cart']) {
            updateCount(applySection(sections['mini-cart']));
            open();
          } else {
            window.location.assign(routes.cart || '/cart');
          }
          track('add_to_cart', {
            product_id: result.data.product_id,
            variant_id: result.data.variant_id,
            quantity: result.data.quantity
          });
        })
        .catch(function () {
          // Nätverksfel: låt formuläret gå den vanliga vägen i stället.
          form.submit();
        })
        .finally(function () {
          if (submitButton) submitButton.classList.remove('is-loading');
        });
    });
  })();

  /* ============================================================
     6. Varukorgssidans stegare
     ============================================================
     Utan JS fungerar varukorgen via <input name="updates[]"> + "Uppdatera
     varukorg". Med JS visas +/- och formuläret skickas vid ändring. */

  (function cartPageModule() {
    var cartForm = document.querySelector('[data-cart-form]');
    if (!cartForm) return;

    document.documentElement.classList.add('infinel-has-js');

    var submitCart = function () {
      if (cartForm.requestSubmit) {
        cartForm.requestSubmit();
      } else {
        cartForm.submit();
      }
    };

    cartForm.querySelectorAll('[data-qty-input]').forEach(function (input) {
      var group = input.closest('.infinel-qty');
      if (group) {
        group.querySelectorAll('[data-qty-delta]').forEach(function (btn) {
          btn.hidden = false;
          btn.addEventListener('click', function () {
            var delta = parseInt(btn.getAttribute('data-qty-delta'), 10) || 0;
            var next = (parseInt(input.value, 10) || 0) + delta;
            if (next < 0) next = 0;
            input.value = next;
            submitCart();
          });
        });
      }
      input.addEventListener('change', submitCart);
    });
  })();

  /* ============================================================
     7. Katalogsidor: filter-sheet och "Visa fler"
     ============================================================
     Filtret i sig är ren CSS (se assets/facets.css). Här läggs bara Escape-
     stängning, mätevent och progressiv paginering till. */

  (function catalogModule() {
    var filterState = document.querySelector('.infinel-filters-state');

    if (filterState) {
      var filterPanel = document.querySelector('.infinel-filters');
      if (filterPanel) {
        filterPanel.querySelectorAll('label[for="FiltersDrawer"]').forEach(function (label) {
          label.setAttribute('role', 'button');
          label.tabIndex = 0;
          label.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); label.click(); }
          });
        });
        filterState.addEventListener('change', function () {
          if (!window.matchMedia('(max-width: 1023px)').matches) return;
          if (filterState.checked) {
            var targets = focusables(filterPanel);
            if (targets[0]) targets[0].focus();
          } else filterState.focus();
        });
      }
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && filterState.checked && filterPanel && window.matchMedia('(max-width: 1023px)').matches) {
          var targets = focusables(filterPanel);
          var first = targets[0];
          var last = targets[targets.length - 1];
          if (targets.length && (event.shiftKey ? document.activeElement === first : document.activeElement === last)) {
            event.preventDefault();
            (event.shiftKey ? last : first).focus();
          }
        }
        if (event.key !== 'Escape' || !filterState.checked) return;
        event.preventDefault();
        filterState.checked = false;
        // Fokus tillbaka till checkboxen: fokusringen visas på dess label i CSS.
        filterState.focus();
      });
    }

    document.addEventListener('click', function (event) {
      var applied = event.target.closest('[data-filter-value]');
      if (applied) {
        track('filter_used', { filter: applied.getAttribute('data-filter-value'), action: 'apply' });
        return;
      }
      var removed = event.target.closest('[data-filter-remove]');
      if (removed) {
        track('filter_used', { filter: removed.getAttribute('data-filter-remove'), action: 'remove' });
      }
    });

    if (config.appFreeSearch) return;

    var grid = document.querySelector('[data-product-grid]');
    var moreButton = document.querySelector('[data-load-more]');
    if (!grid || !moreButton) return;

    var pages = document.querySelector('.infinel-pagination__pages');
    var status = document.createElement('p');
    status.className = 'visually-hidden';
    status.setAttribute('aria-live', 'polite');
    moreButton.after(status);

    // Sifferlänkarna ligger kvar (crawlbara och enda vägen utan JS) och hålls
    // synkade med varje inläst sida, så de aldrig pekar på fel läge.
    moreButton.hidden = false;

    moreButton.addEventListener('click', function () {
      var url = moreButton.getAttribute('data-load-more');
      if (!url) return;

      moreButton.classList.add('is-loading');
      track('load_more', { url: url });

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Sidan kunde inte hämtas');
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = parsed.querySelector('[data-product-grid]');
          if (!nextGrid) throw new Error('Inga fler produkter i svaret');

          var added = Array.prototype.slice.call(nextGrid.children);
          var firstNew = added[0];
          added.forEach(function (card) {
            grid.appendChild(card);
          });

          var nextButton = parsed.querySelector('[data-load-more]');
          if (nextButton) {
            moreButton.setAttribute('data-load-more', nextButton.getAttribute('data-load-more'));
          } else {
            moreButton.remove();
          }

          var nextPages = parsed.querySelector('.infinel-pagination__pages');
          if (pages && nextPages) pages.innerHTML = nextPages.innerHTML;

          status.textContent = added.length + ' produkter till inlästa.';

          // Tangentbordsfokus fortsätter där listan växte, inte längst upp.
          var firstLink = firstNew && firstNew.querySelector('a[href]');
          if (firstLink) {
            firstLink.setAttribute('tabindex', '-1');
            firstLink.focus();
          }
        })
        .catch(function () {
          // Sifferlänkarna finns kvar — knappen tas bort så att kunden använder dem.
          status.textContent = 'Kunde inte läsa in fler produkter. Använd sidnumren nedan.';
          moreButton.remove();
        })
        .finally(function () {
          moreButton.classList.remove('is-loading');
        });
    });
  })();

  /* ============================================================
     8. Relaterade produkter (Product Recommendations API)
     ============================================================ */

  function loadProductRecommendations(root) {
    (root || document).querySelectorAll('[data-product-recommendations][data-url]').forEach(function (section) {
      if (section.getAttribute('data-has-products') === 'true' || section.getAttribute('data-loading') === 'true') return;

      section.setAttribute('data-loading', 'true');
      fetch(section.getAttribute('data-url'))
        .then(function (response) {
          if (!response.ok) throw new Error('Kunde inte hämta produktrekommendationer');
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var replacement = parsed.querySelector('[data-product-recommendations]');
          if (!replacement || replacement.getAttribute('data-has-products') !== 'true') {
            section.remove();
            return;
          }
          section.replaceWith(replacement);
        })
        .catch(function () {
          section.removeAttribute('data-loading');
        });
    });
  }

  loadProductRecommendations(document);
  document.addEventListener('shopify:section:load', function (event) {
    loadProductRecommendations(event.target);
  });

  /* ---- 9. Utskrift ----------------------------------------------------
     Specifikationerna ligger i <details> som är ihopfällda på skärmen. Skrivs
     sidan ut i det läget får man rubrikerna men inte innehållet — vilket är
     hela anledningen till att någon skriver ut en produktsida.

     print-CSS försöker samma sak, men motorerna är inte överens om huruvida
     en stängd <details> går att fälla ut med enbart CSS. Här öppnas de på
     riktigt före utskrift och stängs igen efteråt, så skärmläget är oförändrat.
     Bara de som var stängda återställs — användarens egna val respekteras. */
  function setupPrintExpansion() {
    var reopened = [];

    function expand() {
      reopened = [];
      var list = document.querySelectorAll('details:not([open])');
      for (var i = 0; i < list.length; i++) {
        list[i].open = true;
        reopened.push(list[i]);
      }
    }

    function restore() {
      for (var i = 0; i < reopened.length; i++) reopened[i].open = false;
      reopened = [];
    }

    window.addEventListener('beforeprint', expand);
    window.addEventListener('afterprint', restore);

    /* Safari saknade länge beforeprint/afterprint och driver dem via matchMedia. */
    if (window.matchMedia) {
      var mql = window.matchMedia('print');
      var onChange = function (event) {
        if (event.matches) expand();
        else restore();
      };
      if (typeof mql.addEventListener === 'function') mql.addEventListener('change', onChange);
      else if (typeof mql.addListener === 'function') mql.addListener(onChange);
    }
  }

  setupPrintExpansion();
})();
